import { Container, Row, Col, Badge, Card } from "react-bootstrap";
import { showMoney } from "./Data/Money";
import { useLoaderData, useNavigate } from "react-router-dom";
import { Button } from "./Controls/Button";
import { PencilFill } from "react-bootstrap-icons";
import { Plan } from "./Data/ApiTypes";
import { useAtom } from "jotai";
import { authAtom } from "./Data/Atoms";
import { canPerformAction, extractClaims } from "./helpers/AuthorizationManager";

export function FacilityPlanListPage() {
  const nav = useNavigate();
  const plans = useLoaderData() as Plan[];
  const [auth] = useAtom(authAtom);
  const canEditPlan = canPerformAction(extractClaims(auth), 'edit-plan');

  return (
    <Container fluid className="px-0 px-sm-3">
      {canEditPlan && (
      <Row className="justify-content-start mb-3">
        <Col xs="auto">
          <Button className="w-100 btn-main mt-1" onClick={() => nav("create")}>
            Create New Monthly Plan
          </Button>
        </Col>
      </Row>
      )}

      <Row className="justify-content-start">
        <Col xl="6" xxl="5">
          {plans.map((plan) => {
            const isPrivateOrUsageBased = plan.isPrivate || plan.isUsageBasedBilling;

            return <Card key={plan.planId} className="mb-3">
              <Card.Body>
                <div className="d-flex align-items-start gap-2">
                  <div className="flex-fill">
                    <div className="d-flex align-items-center gap-2 mb-1">
                      {plan.isPrivate && !plan.isUsageBasedBilling && <Badge bg="primary">Private</Badge>}
                      {plan.isOneTermPlan && <Badge bg="primary">One Term</Badge>}
                      {plan.isUsageBasedBilling && <Badge bg="primary">Usage Based</Badge>}
                      <span className="fs-5 fw-bold">{plan.name}</span>
                    </div>
                    {plan.accessHours && (
                      <div className="text-muted" style={{ fontSize: ".85rem" }}>
                        {plan.accessHours}
                      </div>
                    )}
                  </div>
                  <div className="d-flex flex-column align-items-end gap-2">
                    {plan.planPrice && !isPrivateOrUsageBased
                      ? <span className="fw-bold">{showMoney(plan.planPrice.price)}</span>
                      : <Badge bg="secondary">Not Listed</Badge>}
                    <Button
                      variant="sm"
                      className="d-flex align-items-center"
                      style={{ padding: "1px 0.5em" }}
                      onClick={() => nav(plan.isUsageBasedBilling ? `${plan.planId}/edit` : `${plan.planId}`)}>
                      <PencilFill color="maroon" />&nbsp; {plan.isUsageBasedBilling ? (canEditPlan ? "Edit Plan" : "View Plan") : "View Plan"}
                    </Button>
                  </div>
                </div>
              </Card.Body>
            </Card>
          })}
        </Col>
      </Row>
    </Container>
  );
}
